const socketEventTypes = {
  1: "COMPANY_ADD_CALL",
  2: "CONTACT_ADD_CALL",
  4: "OPPORTUNITY_ADD_CALL",
  15: "OPPORTUNITY_ADD_CALL"
};

export default socketEventTypes;
